import React from 'react';
import { Typography, Divider } from 'antd';
import '../../../Styles/ResearchLabs.css'; // Create and import this CSS file for styling
import investigatorImage from '../../../Assets/ResearchLabs/SDSSL/Director/Dr-Shafi-Ullah.jpeg';

const { Title, Text } = Typography;

const PrincipalInvestigatorSection = () => {
  return (
    <section className="principal-investigator-section">
      <div className="investigator-content">
        <Title level={2} className="investigator-title">Principal Investigator/Lab Director</Title>
        <Divider className="ncgsa-divider" />
        <img src={investigatorImage} alt="Dr. Shafi Ullah" className="investigator-photo" />
        <Text strong className="investigator-name">Dr. Shafi Ullah</Text>
        <Text strong className="investigator-affiliation">BUITEMS, Quetta</Text>
        <a href="mailto:shafi.ullah@buitems.edu.pk" className="investigator-contact">shafi.ullah@buitems.edu.pk</a>
        <a href="tel:111777111" className="investigator-contact">111-777-111 Ext:491</a>
      </div>
    </section>
  );
};

export default PrincipalInvestigatorSection;
